import { Link } from "react-router-dom";
import SEO from '../pages/SEO';
import { Button } from "../ui/button"
import { Card, CardContent } from "../ui/card"
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react"
import InsuranceSection from "../components/InsuranceSection.js"
import Nageswara from "../images/Sri Puvvada Nageswara Rao.jpg"
import Ajay from "../images/Shri Puvvada Ajay Kumar.jpeg"
import Nayan from "../images/Dr. Nayan Raj Puvvada.jpeg"




import { Star, Quote } from "lucide-react";
import Madankishore from "../images/madankishore testimonal.png"
import GOVIND from "../images/GOVIND testimonal.png"
import Murali from "../images/Murali testimonal.png"
import Raja from "../images/Raja testimonal.png"
import Krishna from "../images/Murali testimonal.png"


import React from "react";
import {
  // Icons used in the page
  Brain,
  Microscope,
  Syringe,
  Scissors,
  Droplet,
  FlaskConical,
  UserRound,
  Baby,
  Shield,
  ShieldAlert,
  Bone,
  Pill,
  Dumbbell,
  Hospital,
  Accessibility,
  Apple,
  Eye,
  Headphones,
  Image as ImageIcon,
  HeartPulse,
  Stethoscope,
  Stethoscope as Gastro,      // for Gastroenterology

  // UI / misc
  Phone,
  Mail,
  MapPin,
  CheckCircle2,
  Users,
  Award,
  Heart,
} from "lucide-react";
const ToothIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-tooth"
  >
    <path d="M12 2C9 2 7 5 7 8c0 2 1 4 1 6s-1 4-1 6c0 1 1 2 2 2s2-1 2-2c0-2 0-4 1-6s1-4 1-6c0-3-2-6-5-6z" />
  </svg>
);


export default function HospitalLandingPage() {
  const navigate = useNavigate();

  /* ---------------- FORM STATE ---------------- */
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    gender: "",
    dob: "",
    visitType: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_gswhjkq",
        "template_2dx2ahi", // 🔁 replace with real template ID
        {
          name: formData.firstName + " " + formData.lastName,
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
          phone: formData.phone,
          gender: formData.gender,
          appointment_date: formData.appointmentDate,
          visit_type: formData.visitType,
        },
        "EQIu7gTx1Ns0SiRpq" // 🔁 replace with real public key
      )
      .then(() => {
        alert("Appointment booked successfully!");
        navigate("/");
      })
      .catch(() => {
        alert("Submission failed. Please try again.");
      });
  };


const SpecialtyCard = ({ item }) => (
  <Link
    to={item.link}
    className="bg-white border border-gray-200 rounded-lg shadow-sm
               hover:shadow-md transition flex flex-col items-center
               justify-center p-8 text-center"
  >
    <div
      className="w-14 h-14 flex items-center justify-center 
                 border rounded-md mb-4"
      style={{ color: "#0d9488" }}
    >
      {React.cloneElement(item.icon, { className: "w-7 h-7" })}
    </div>

    <h3 className="font-semibold text-gray-800 text-base">
      {item.name}
    </h3>
  </Link>
);



  const [activeTab, setActiveTab] = useState("ear")
  const [currentSlide, setCurrentSlide] = useState(0)
    const isMobile = window.innerWidth < 768;


  const whyChoose = [
    {
      icon: Users,
      title: "Experienced ENT Surgeons & Specialists",
      description: "Highly trained doctors with years of ENT expertise",
    },
    {
      icon: Stethoscope,
      title: "Advanced Endoscopic ENT Procedures",
      description: "Minimally invasive surgeries for faster recovery",
    },
    {
      icon: Award,
      title: "Modern Audiology & Diagnostics",
      description: "Complete hearing and balance assessments",
    },
    {
      icon: Heart,
      title: "Child-Friendly Pediatric ENT Care",
      description: "Safe, comfortable treatment for children",
    },
    {
      icon: CheckCircle2,
      title: "Comprehensive Allergy & Sinus Care",
      description: "Diagnosis and long-term management",
    },
    {
      icon: Shield,
      title: "All Insurance Accepted",
      description: "Cashless treatment for eligible patients",
    },
  ]

  const specialists = [
    {
      name: "Dr Ahmed Abdul Majid Hussaini",
    //   specialty: "Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
      description: "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
      image: "/1 Dr Ahmed Abdul Majid Hussaini.jpg",
    },
    {
    name: "Dr Uma Pokala",
   // specialty:
      //"Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
    description:
      "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
    image: "/2 Dr Uma Pokala.jpg",
  },
  {
    name: "Dr Maryada Sravani",
   //specialty:
      //"Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
    description:
      "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
    image: "/Dr Maryada Sravani.jpg",
  },
  {
    name: "Dr Sivapuram Kavya",
   //specialty:
      //"Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
    description:
      "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
    image: "/3 Dr Sivapuram Kavya.jpg",
  },
  {
    name: "Dr Pasunooti Shravya",
   // specialty:
      //"Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
    description:
      "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
    image: "/Dr Pasunooti Shravya.jpg",
  },
  {
    name: "Dr Surabhi Periwal",
    //specialty:
      //"Expert ENT Treatment & Specialists in Bachupally, Miyapur. Advanced diagnosis and treatment for ear, nose & throat disorders. Minimally invasive procedures for faster relief and recovery",
    description:
      "Specialized in ear, nose, and throat disorders with a focus on surgical interventions.",
    image: "/4 Dr Surabhi Periwal.jpg",
  },
  ]

  const faqs = [
    {
        question: "What is MAMS Hospitals?",
        answer:
        "MAMS Hospitals (Mamatha Academy of Medical Sciences & Hospital) is a 700-bed multispecialty teaching hospital located in Bachupally, Hyderabad. It offers comprehensive healthcare under one roof with advanced clinical services. ",
    },
    {
        question: "What specialties and departments are available?",
        answer:
        "MAMS Hospitals provides care across many departments including:General Medicine,General Surgery,Orthopaedics,Obstetrics & Gynaecology,Paediatrics,Dermatology,ENT and Ophthalmology…and other specialty services."
    },
    {
        question: "Does MAMS Hospitals have emergency services?",
        answer:
        "Yes — 24×7 Emergency & Trauma Care is available with dedicated staff, equipment, and ICU support to manage urgent medical needs.",
    },
    {
        question: "What types of insurance are accepted at MAMS Hospitals?",
        answer:
        "MAMS Hospitals accepts Aarogyasri, government health schemes, and select private insurance policies. Please contact the insurance desk for confirmation.",
    },
    {
        question: "What are your consultation timings?",
        answer:
        "Monday to Saturday, 9:00 AM to 5:00 PM. Emergency services are available 24/7.",
    },
  ]
  const superSpecialties = [
  {
     name: "Cardiology", 
    description: "Comprehensive heart care with advanced diagnostics and treatments.", 
    icon: <HeartPulse className="w-8 h-8 text-teal-600"  /> ,
    link: "/departments/cardiology"

  },
  // { name: "Cardiothoracic Surgery",
  //    description: "Surgical procedures for heart, lungs, and chest diseases.", 
  //    icon: <Activity className="w-8 h-8 text-teal-600" /> 
  //   },

  {
     name: "Neurology", 
    description: "Expert care for conditions affecting the brain and nervous system.",
     icon: <Brain className="w-8 h-8 text-teal-600" />,
      link: "/departments/neurology" 
    },
  {
     name: "Neurosurgery",
      description: "Advanced surgical interventions for brain and spine disorders.", 
      icon: <Microscope className="w-8 h-8 text-teal-600" />,
      link: "/departments/neurosurgery" 
     },
  { 
    name: "Urology",
     description: "Specialized care for urinary tract and male reproductive health.",
      icon: <Droplet className="w-8 h-8 text-teal-600" />,
      link: "/departments/urology"
  },
  { 
    name: "Nephrology", 
    description: "Treatment for kidney diseases and renal health management.",
     icon: <Stethoscope className="w-8 h-8 text-teal-600" />,
     link:"/departments/nephrology"
     },
  // { name: "Medical Oncology", description: "Comprehensive cancer care with personalized treatment plans.", icon: <Syringe className="w-8 h-8 text-teal-600" /> },
  // { name: "Surgical Oncology", description: "Surgical interventions for the treatment of various cancers.", icon: <Scissors className="w-8 h-8 text-teal-600" /> },
  { 
    name: "Endocrinology", 
    description: "Management of hormonal disorders and metabolic conditions.",
     icon: <FlaskConical className="w-8 h-8 text-teal-600" />,
     link:"/departments/endocrinology"
     },

  {
     name: "Plastic Surgery", 
    description: "Reconstructive and cosmetic surgical procedures.", 
    icon: <UserRound className="w-8 h-8 text-teal-600" /> ,
     link: "/departments/plasticsurgery" 
  },
  { 
    name: "Pediatric Surgery", 
    description: "Specialized surgical care for infants, children, and adolescents.", 
    icon: <Baby className="w-8 h-8 text-teal-600" /> ,
    link: "/departments/pediatric-surgery"
  },
  // { name: "Neonatology", description: "Care for newborns, including premature and critically ill babies.", icon: <BabyIcon className="w-8 h-8 text-teal-600" /> },
  { 
    name: "Medical & Surgical Gastroenterology",
     description: "Treatment for digestive system disorders and diseases.", 
     icon: <Gastro className="w-8 h-8 text-teal-600" />,
     link: "/departments/gastroenterology"
  },
   { 
    //LEAN LIFE
    name: "Bariatric Surgery",
    description: "Bariatric Surgery is a wellness brand promoting healthy, balanced living.",
    icon: <Apple className="w-8 h-8 text-teal-600" />,
    link: "/departments/leanlife"
    },
  ];
  const broadSpecialties = [
  {
     name: "General Medicine",
     description: "Primary healthcare for adults covering a wide range of conditions.", 
    icon: <Stethoscope className="w-8 h-8 text-teal-600" />, 
    link: "/departments/general-medicine"
  },
  {
     name: "General Surgery", 
     description: "Surgical care for a variety of conditions requiring operative treatment.", 
     icon: <Scissors className="w-8 h-8 text-teal-600" />,
      link: "/departments/general-surgery"
     },
  {
    name: "Orthopaedics",
    description: "Expert care for bones, joints, ligaments, tendons, and muscles.",
    icon: <Bone className="w-8 h-8 text-teal-600" />,
    link: "/departments/orthopaedics"
  }, 
  {
     name: "Obstetrics & Gynaecology",
      description: "Complete women's health care from adolescence to post-menopause.",
       icon: <Baby className="w-8 h-8 text-teal-600" />, 
       link: "/departments/obstetrics-gynaecology"
  },
  { 
    name: "Paediatrics",
     description: "Specialized healthcare for infants, children, and adolescents.",
      icon: <HeartPulse className="w-8 h-8 text-teal-600" />,
      link: "/departments/paediatrics"
  },
  {
     name: "Dermatology (DVL)", 
     description: "Diagnosis and treatment of skin, hair, and nail conditions.", 
     icon: <UserRound className="w-8 h-8 text-teal-600" />,
     link: "/departments/dermatology"
     },
  { name: "ENT", 
    description: "Care for ear, nose, throat, and related head and neck disorders.", 
    icon: <Headphones className="w-8 h-8 text-teal-600" /> ,
     link: "/departments/ent" 
  },
  { 
    name: "Ophthalmology",
     description: "Comprehensive eye care and vision services.",
      icon: <Eye className="w-8 h-8 text-teal-600" />,
      link: "/departments/ophthalmology" 
  },
  {
     name: "Radiology & Imaging Sciences", 
     description: "Advanced diagnostic imaging services and interventions.",
      icon: <ImageIcon className="w-8 h-8 text-teal-600" />,
      link: "/departments/radiology" 
     },
  {
     name: "Psychiatry",
      description: "Mental health care and psychological support services.",
       icon: <Brain className="w-8 h-8 text-teal-600" /> ,
      link: "/departments/psychiatry" 
  },
  {
     name: "Emergency & Trauma",
      description: "24/7 critical care for accidents, injuries, and medical emergencies.", 
      icon: <ShieldAlert className="w-8 h-8 text-teal-600" />,
      link: "/departments/emergency-trauma" 
     },
  { 
    name: "Pain Medicine",
     description: "Management of acute and chronic pain conditions.",
     icon: <Pill className="w-8 h-8 text-teal-600" />,
     link: "/departments/pain-medicine" 
     },
  { 
    name: "Sports Medicine", 
    description: "Specialized care for sports-related injuries and performance enhancement.", 
    icon: <Dumbbell className="w-8 h-8 text-teal-600" />,
    link: "/departments/sports-medicine" 
   },
  { 
    name: "Critical Care",
     description: "Intensive care for patients with severe or life-threatening illnesses.", 
     icon: <Hospital className="w-8 h-8 text-teal-600" />,
    link: "/departments/critical-care" 
   },
  {
     name: "Anaesthesiology",
      description: "Ensuring patient comfort and safety during surgical procedures.",
       icon: <Syringe className="w-8 h-8 text-teal-600" />,
       link: "/departments/anaesthesiology" 
  },
  {
     name: "Dental",
      description: "Comprehensive dental care services for all age groups.",
      icon: <ToothIcon className="w-8 h-8 text-teal-600" />,
      link: "/departments/dental"
      },
  // { name: "Pulmonology", description: "Treatment for respiratory system diseases and breathing disorders.", icon: <Wind className="w-8 h-8 text-teal-600" /> },
  {
     name: "Physiotherapy",
      description: "Helps restore movement and function through physical treatments and exercises.", 
      icon: <Accessibility className="w-8 h-8 text-teal-600" />,
      link: "/departments/physiotherapy"

     },
  // { name: "Radiology", description: "Radiology uses medical imaging to diagnose and monitor diseases and conditions.", icon: <Camera className="w-8 h-8 text-teal-600" /> },
 
  ];



  const goToSlide = (index) => {
    setCurrentSlide(index)
  }

 const visibleCards = isMobile ? 1 : 3

const maxSlide = Math.max(specialists.length - visibleCards, 0)


const nextSlide = () => {
  setCurrentSlide((prev) => Math.min(prev + 1, maxSlide))
}

const prevSlide = () => {
  setCurrentSlide((prev) => Math.max(prev - 1, 0))
}


  const totalDots = specialists.length - 2
 const [currentTestimonial, setCurrentTestimonial] = useState(0)
  const testimonials = [
    {
      id: 1,
      name: "madankishore panchangam",
      location: "Bachupally",
      rating: 5,
      text: "What I feel is excellent hospital in all aspects especially team of doctors.. My father spent almost six days in the hospital for lung infection. Undoubtedly I suggest this hospital for any issue. Only issue we faced is ward boys but supervisor venkatesh garu and lady supervisor they helped very well. Requesting management to take quick preventive measures during workers strike otherwise patients will suffer. Overall experience is good.Thanq MAMS.",
      treatment: "Lung Infection",
      image: Madankishore,
      
    },
    {
      id: 2,
      name: "Govind Yadav",
      location: "Bachupally",
      rating: 5,
      text: "Very good hospital in bachupally. I Really felt very happy by Dr Akshay sir and Dr Divya ma'am. The way they treat the patient is really awesome. I am so happy to be such doctor's in the hospital. Thank you so much Dr Akshay sir and team.",
      treatment: "Emergency Care",
      image: GOVIND,
    },
    {
      id: 3,
      name: "Milind Bhandarkar",
      location: "Bachupally",
      rating: 5,
      text: "One of the best Treatment by doctor and supporting Staff, first Time I came to Hyderabad feels good during Treatment for my Daughter.Good supporting Staff.Thanks Mamta Hospital Doctor and Staff.",
      treatment: "Emergency Care",
      image: Murali,
    },
    {
      id: 4,
      name: "Raja Maddala",
      location: "Bachupally",
      rating: 4,
      text: "Mams Hospital offers exceptional treatment and scanning services in a warm, welcoming environment. The staff are compassionate and professional, ensuring every patient feels cared for. The hospital is clean, well-maintained, and equipped with modern technology, making it a reliable choice for quality healthcare.",
      treatment: "Emergency Care",
      image: Raja,
    },
    {
      id: 5,
      name: "Murali Krishna yannam",
      location: "Bachupally",
      rating: 5,
      text: "I feel like it is an excellent hospital. In this hospital the doctors are too good and they treating patients like a family . The hospital staff is very respectful and responsible. Especially having great experience with radiology department.",
      treatment: "Radiology",
      image: Krishna,
    },
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [testimonials.length])



  return (
    <div className="flex flex-col min-h-screen">
      <SEO
        title="Best Multispecialty Hospital in Hyderabad | MAMS Hospitals Bachupally"
        description="MAMS Hospitals is a leading 700-bed multispecialty hospital in Bachupally, Hyderabad offering expert doctors, advanced diagnostics, 24/7 emergency care, and treatment across 30+ specialties."
        keywords="best hospital Hyderabad, multispecialty hospital Bachupally, MAMS Hospitals, hospital near Miyapur, 24 hour emergency hospital Hyderabad, best doctors Hyderabad"
        canonicalUrl="https://mamshospitals.com/best-hospital-in-hyderabad"
      />
      <section className="bg-primary py-12">
        <div className="container mx-auto px-4 max-w-7xl">

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">

            {/* 1️⃣ CONTENT CONTAINER */}
            <div className="text-white">
                <h1 className="text-4xl font-bold mb-6">
                Best  Hospital in Hyderabad
                </h1>
                <p className="text-lg mb-4">
                MAMS Hospitals – Multispecialty Hospital in Bachupally, Hyderabad
                </p>
                <p className="text-white/90 leading-relaxed mb-6">
                MAMS Hospitals is a leading multispecialty hospital in Bachupally, Hyderabad, offering expert doctors, advanced diagnostics, emergency care, and compassionate treatment across major medical specialties.
                </p>

                <a href="tel:+917399999981">
                <Button className="bg-white text-teal-600">
                    Call Now
                </Button>
                </a>
            </div>

            {/* 2️⃣ IMAGE CONTAINER */}
            <div className="relative h-[420px] rounded-2xl overflow-hidden shadow-2xl bg-white">
                <img
                src="/hospital%20image.ed3c535aa893e16c0eda.jpg"
                alt="Hospital"
                className="w-full h-full object-cover"
                />
            </div>

            {/* 3️⃣ FORM CONTAINER */}
            <div className="bg-white rounded-2xl shadow-2xl p-6">
                <h3 className="text-xl font-bold mb-6 text-teal-600">
                    Book Appointment
                </h3>

                <form className="space-y-4" onSubmit={handleSubmit}>

                    {/* NAME */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input
                        type="text"
                        name="firstName"
                        placeholder="First Name*"
                        required
                        onChange={handleChange}
                        className="w-full border rounded-md px-4 py-2"
                    />
                    <input
                        type="text"
                        name="lastName"
                        placeholder="Last Name*"
                        required
                        onChange={handleChange}
                        className="w-full border rounded-md px-4 py-2"
                    />
                    </div>

                    {/* EMAIL + PHONE */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input
                        type="email"
                        name="email"
                        placeholder="Email Address*"
                        required
                        onChange={handleChange}
                        className="w-full border rounded-md px-4 py-2"
                    />
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone Number*"
                      required
                      maxLength={10}
                      pattern="[0-9]{10}"
                      inputMode="numeric"
                      onChange={(e) => {
                        // allow only numbers & limit to 10 digits
                        e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10)
                        handleChange(e)
                      }}
                      className="w-full border rounded-md px-4 py-2"
                    />

                    </div>

                    {/* GENDER + DOB */}
                    
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                        <select
                            name="gender"
                            required
                            onChange={handleChange}
                            className="w-full border rounded-md px-4 py-2"
                        >
                            <option value="">Select Gender*</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                        </select>

                        {/* Appointment Date with label (mobile-safe) */}
                          <div className="flex flex-col">
                            <label className="block md:hidden text-sm font-medium text-gray-600 mb-1">
                              Appointment Date *
                            </label>

                            <input
                              type="date"
                              name="appointmentDate"
                              required
                              min={new Date().toISOString().split("T")[0]}
                              onChange={handleChange}
                              className="w-full border rounded-md px-4 py-2 text-gray-700"
                            />
                          </div>



                        </div>


                    {/* VISIT TYPE */}
                    <div>
                    <p className="text-sm font-medium mb-2">
                        Is this your first visit to MAMS Hospitals?
                    </p>

                    <div className="flex gap-6 text-sm">
                        <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="visitType"
                            value="New Patient"
                            required
                            onChange={handleChange}
                        />
                        Yes, I’m a new patient
                        </label>

                        <label className="flex items-center gap-2">
                        <input
                            type="radio"
                            name="visitType"
                            value="Existing Patient"
                            onChange={handleChange}
                        />
                        No, I’ve been here before
                        </label>
                    </div>
                    </div>

                    {/* SUBMIT */}
                    <button
                    type="submit"
                    className="w-full bg-teal-600 text-white py-3 rounded-md font-semibold"
                    >Book Appointment</button>
                    </form>
            </div>
            </div>
        </div>
      </section>




     {/* Statistics Section */}
      <section className="py-12 bg-white border-b">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-teal-600 mb-2">98%</div>
              <div className="text-gray-600 font-medium">Patient Satisfaction</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-teal-600 mb-2">50,000+</div>
              <div className="text-gray-600 font-medium">Happy Patients</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-teal-600 mb-2">4.8/5</div>
              <div className="text-gray-600 font-medium">Average Rating</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-teal-600 mb-2">30+</div>
              <div className="text-gray-600 font-medium">Years of Trust</div>
            </div>
          </div>
        </div>
      </section>


      {/* Leadership */}
      <section className="py-8 md:py-16 px-0 md:px-4 bg-primary/5">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Leadership</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Led by experienced healthcare professionals and administrators committed to upholding our founding vision.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm text-center">
              <div className="w-32 h-40 mx-auto mb-4 overflow-hidden square-full ">
                <img
                  src={Nageswara}
                  alt="Dr. Ramesh Rao"
                  className="object-cover w-full h-full"
                />
              </div>
              <h3 className="text-xl font-bold mb-1">Sri Puvvada Nageswara Rao</h3>
              <p className="text-gray-500 mb-3">Founder</p>
              <p className="text-gray-600 text-sm">
                Mamata Educational Society was established in May 1996 by Sri Puvvada Nageswara Rao, who is a renowned politician ,a social worker and by dedication educationist and philanthropist of repute.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm text-center">
              <div className="w-32 h-40 mx-auto mb-4 overflow-hidden square-full">
                <img
                  src={Ajay}
                  alt="Dr. Meera Sharma"
                  className="object-cover w-full h-full"
                />
              </div>
              <h3 className="text-xl font-bold mb-1">Sri Puvvada Ajay Kumar</h3>
              <p className="text-gray-500 mb-3">Chairman</p>
              <p className="text-gray-600 text-sm">
                Shri Puvvada Ajay Kumar is the Chairman of Mamata Academy of Medical Sciences, bachupally in state of Telangana.He was the Transport Minister of Telangana since 2019-2023.He is also the chairman of Mamata Medical, Nursing and Dental colleges in Khammam.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm text-center">
              <div className="w-32 h-40 mx-auto mb-4 overflow-hidden square-full">
                <img
                  src={Nayan}
                  alt="Mr. Vijay Kumar"
                  className="object-cover w-full h-full"
                />
              </div>
              <h3 className="text-xl font-bold mb-1">Dr. Nayan Raj Puvvada</h3>
              <p className="text-gray-500 mb-3">Managing Director</p>
              <p className="text-gray-600 text-sm">
                Dr Nayan Raj Puvvada is at the helm of the thought and ideology that has taken Mamata Academy of Medical Sciences to heights of perfection and success in terms of offering quality healthcare to patients as well as imparting the best medical education.
              </p>
            </div>
          </div>
        </div>
      </section>


     {/*Specialities */}
  
    <section className="py-12">
    <div className="container mx-auto max-w-6xl">
        <div className="text-center max-w-3xl mx-auto mb-14">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Our Medical Services
        </h2>
        <p className="text-gray-600 text-lg">
            MAMS Hospitals offers comprehensive care across super and broad specialties,
            ensuring all your healthcare needs are met under one roof.
        </p>
        </div>

        {/* SUPER SPECIALITIES */}
        <div className="mb-16">
        <h3 className="text-2xl font-semibold text-left mb-10">
            Super Specialities
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {superSpecialties.map((item, i) => (
            <SpecialtyCard key={i} item={item} />
            ))}
        </div>
        </div>

        {/* BROAD SPECIALITIES */}
        <div>
        <h3 className="text-2xl font-semibold text-left mb-10">
            Broad Specialities
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {broadSpecialties.map((item, i) => (
            <SpecialtyCard key={i} item={item} />
            ))}
        </div>
        </div>
    </div>
    </section>


    {/* InsuranceSection  */}
      <InsuranceSection />




    {/* TestimonialsSection  */}
    <section className="py-8 md:py-16 px-0 md:px-4  bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-2">What Our Patients Say</h2>
          <p className="text-apple-gray-400 max-w-2xl mx-auto">
            Real stories from real patients who have experienced exceptional care at MAMS Hospitals.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <Card className="border-apple-gray-100 rounded-3xl overflow-hidden shadow-lg">
            <CardContent className="p-8 md:p-12">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <div className="flex-shrink-0">
                  <img
                    src={testimonials[currentTestimonial].image || "/placeholder.svg"}
                    alt={testimonials[currentTestimonial].name}
                    className="w-20 h-20 rounded-full object-cover border-4 border-apple-teal/20"
                  />
                </div>

                <div className="flex-1 text-center md:text-left">
                  <Quote className="h-8 w-8 text-apple-teal/30 mb-4 mx-auto md:mx-0" />

                  <p className="text-lg md:text-xl text-apple-gray-400 mb-6 italic">
                    "{testimonials[currentTestimonial].text}"
                  </p>

                  <div className="flex items-center justify-center md:justify-start gap-1 mb-4">
                    {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                      <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>

                  <div>
                    <div className="font-semibold text-apple-gray-500 text-lg">
                      {testimonials[currentTestimonial].name}
                    </div>
                    <div className="text-apple-gray-300 text-sm">
                      {testimonials[currentTestimonial].location} • {testimonials[currentTestimonial].treatment}
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Dots Navigation */}
          <div className="flex justify-center mt-8 gap-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  index === currentTestimonial ? "bg-apple-teal" : "bg-apple-gray-200 hover:bg-apple-gray-300"
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

      </div>
    </section>

        {/* FAQ Section */}
           <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
          </div>

          <div className="space-y-6">
            {faqs.map((faq, i) => (
              <Card key={i} className="p-6">
                <h3 className="font-bold text-gray-900 mb-3 text-lg">{faq.question}</h3>
                <p className="text-gray-700">{faq.answer}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
     <section className="py-16 px-4 bg-primary text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Schedule Your Consultation Today</h2>
            <p className="text-white/90 max-w-2xl mx-auto">
              Don't let Health problems affect your quality of life. Our specialists are here to help.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <Card className="p-6 text-center bg-white/10 border-white/20 backdrop-blur">
              <Phone className="h-8 w-8 mx-auto mb-4 text-white" />
              <h3 className="font-bold mb-2 text-white">Call Us</h3>
              <a href="tel:+91-7399999981" className="text-white/90 hover:text-white">
                +91-7399999981
              </a>
            </Card>

            <Card className="p-6 text-center bg-white/10 border-white/20 backdrop-blur">
              <Mail className="h-8 w-8 mx-auto mb-4 text-white" />
              <h3 className="font-bold mb-2 text-white">Email Us</h3>
              <a href="mailto:info@mamshospital.com" className="text-white/90 hover:text-white">
                info@mamshospital.com
              </a>
            </Card>

            <Card className="p-6 text-center bg-white/10 border-white/20 backdrop-blur">
              <MapPin className="h-8 w-8 mx-auto mb-4 text-white" />
              <h3 className="font-bold mb-2 text-white">Visit Us</h3>
              <p className="text-white/90 text-sm"> Bachupally,Miyapur, Hyderabad</p>
            </Card>
          </div>

          {/* <div className="text-center">
            <a href="/book-appointment">
              <button className="px-8 py-3 bg-white text-primary rounded-md hover:bg-white/90 transition font-bold text-lg">
                Book Your Appointment Now
              </button>
            </a>
          </div> */}
        </div>
      </section>

      {/* MAP SECTION */}
    <section className="w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] mt-12">
        <div className="w-full h-[420px] md:h-[450px] overflow-hidden shadow-xl rounded-2xl">
            <iframe
            src="https://www.google.com/maps?q=MAMS+Hospitals+Bachupally&output=embed"
            className="w-full h-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="MAMS Hospital Bachupally Map"
            />
        </div>
    </section>

    </div>
  )
}
